import { render, staticRenderFns } from "./lang.vue?vue&type=template&id=61fca331&scoped=true&"
import script from "./lang.vue?vue&type=script&lang=js&"
export * from "./lang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fca331",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61fca331')) {
      api.createRecord('61fca331', component.options)
    } else {
      api.reload('61fca331', component.options)
    }
    module.hot.accept("./lang.vue?vue&type=template&id=61fca331&scoped=true&", function () {
      api.rerender('61fca331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/sys/lang/lang.vue"
export default component.exports